import '../styles/global.scss';
import { mount } from 'svelte';
import Frontend from './Frontend.svelte';
import { ModeService } from './services/ModeService.svelte';
import { PageService } from './services/PageService.svelte';

// - DarkMode|LightMode
ModeService.init();

// - Page by the address bar, internal links without reload
PageService.init();

// - Create frontend
const target = document.getElementById('frontend');
if (target === null) {
    throw new Error('Frontend target element not found.');
}
export default mount(Frontend, { target });
